import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {PhotovoltaikcheckAnfrage} from "../anfrage/photovoltaikcheck.anfrage";
import {FormConfig} from "../../form/form.config";
import {FormGroup} from "@angular/forms";
import {SavingsForm} from "../../stromcheck/ergebnis/savings/savings.form";

/**
 * fomr for setting the electricity price
 */
@Component({
    selector: 'app-photovoltaikcheck-ergebnis-price',
    templateUrl: './ergebnis.price.component.html',
    standalone: false
})
export class ErgebnisPriceComponent implements OnInit {
  /**
   * request object of the user
   */
  @Input() anfrage: PhotovoltaikcheckAnfrage;

  /**
   * toggle for the loading animation
   */
  @Input() loading: boolean;

  /**
   * textkey prefix
   */
  @Input() textkeyPrefix: string;

  /**
   * indicator if the element is hidden or not.
   */
  @Input() isHidden: boolean = true;

  /**
   * eventemitter if the form is saved
   */
  @Output() save = new EventEmitter<{[key: string]: any}>();

  /**
   * eventemitter if the form is closed
   */
  @Output() close = new EventEmitter<void>();

  /**
   * formconfig with form information
   */
  formConfig: FormConfig;

  /**
   * form for the frontend
   */
  form: FormGroup;

  /**
   * error string
   */
  formError: string;

  /**
   * @inheritdoc
   */
  ngOnInit() {
    this.formConfig = new SavingsForm();
    this.form = this.formConfig.getForm();

    // preset data
    this.formConfig.setData(this.anfrage.userInput);
  }

  /**
   * save the input
   */
  saveForm(): void {
    if(!this.form.valid) {
      // form is not valid, show error message
      this.formError = 'form_invalid';
      return;
    }

    this.save.emit(this.formConfig.getData());
  }

  /**
   * reset data in the form
   */
  resetData(): void {
    this.formError = null;
    this.anfrage.userInput.grundpreis_euro_monat = null;
    this.anfrage.userInput.arbeitspreis_cent_kwh = null;
    ['grundpreis_euro_monat', 'arbeitspreis_cent_kwh', 'grundpreis_euro_monat_einheit'].forEach(field => {
      this.form.get(field).setValue(null);
    });

    this.save.emit(this.form.value);
  }

  /**
   * close the form
   */
  closeForm(): void {
    this.close.emit();
  }
}
